export default __webpack_public_path__ + "static/media/here-to-help.c9b53eda.svg";